export default __webpack_public_path__ + "static/media/Garage.e2138cfe.png";